export default __webpack_public_path__ + "static/media/ppu-logo-white.ff4cea73.svg";